<div [hidden]="!active" class="tab-pane directory-tab-container">
    <div class="panel-body">
        <ng-content></ng-content>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/tabs/tab-item/tab-item-property.component.html